import { useEffect, useState } from 'react'

// Mobile detection hook
export function useIsMobile() {
  // Initialize with matchMedia check to prevent flicker
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false

    // Primary check: screen width
    const widthQuery = window.matchMedia('(max-width: 768px)')
    // Secondary check: touch capability with coarse pointer
    const touchQuery = window.matchMedia('(pointer: coarse)')
    // Tertiary check: tablet in portrait
    const tabletPortraitQuery = window.matchMedia('(max-width: 1024px) and (orientation: portrait)')

    return widthQuery.matches || (touchQuery.matches && tabletPortraitQuery.matches)
  })

  useEffect(() => {
    const checkIsMobile = () => {
      // Use matchMedia for all checks (more reliable than window properties)
      const widthQuery = window.matchMedia('(max-width: 768px)')
      const touchQuery = window.matchMedia('(pointer: coarse)')
      const tabletPortraitQuery = window.matchMedia('(max-width: 1024px) and (orientation: portrait)')

      // Also check for mobile user agent as additional signal
      const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

      // Mobile if:
      // 1. Screen width <= 768px
      // 2. OR touch device (coarse pointer) in portrait mode on tablet sizes
      // 3. OR mobile UA with appropriate screen size
      const mobile =
        widthQuery.matches || (touchQuery.matches && tabletPortraitQuery.matches) || (isMobileUA && widthQuery.matches)

      setIsMobile(mobile)
    }

    // Set up media query listeners
    const widthQuery = window.matchMedia('(max-width: 768px)')
    const touchQuery = window.matchMedia('(pointer: coarse)')
    const orientationQuery = window.matchMedia('(orientation: portrait)')

    const handleMediaChange = () => checkIsMobile()

    // Add listeners to all queries
    widthQuery.addEventListener('change', handleMediaChange)
    touchQuery.addEventListener('change', handleMediaChange)
    orientationQuery.addEventListener('change', handleMediaChange)

    // Also listen for resize as fallback
    window.addEventListener('resize', checkIsMobile)

    return () => {
      widthQuery.removeEventListener('change', handleMediaChange)
      touchQuery.removeEventListener('change', handleMediaChange)
      orientationQuery.removeEventListener('change', handleMediaChange)
      window.removeEventListener('resize', checkIsMobile)
    }
  }, [])

  return isMobile
}
